import { render, staticRenderFns } from "./ConsentRequestForm.vue?vue&type=template&id=7b674b16&scoped=true"
import script from "./ConsentRequestForm.vue?vue&type=script&lang=ts"
export * from "./ConsentRequestForm.vue?vue&type=script&lang=ts"
import style0 from "./ConsentRequestForm.vue?vue&type=style&index=0&id=7b674b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b674b16",
  null
  
)

export default component.exports